import { render } from "./workshopApprovalPanel.vue?vue&type=template&id=104e7a00&scoped=true"
import script from "./workshopApprovalPanel.vue?vue&type=script&lang=js"
export * from "./workshopApprovalPanel.vue?vue&type=script&lang=js"

import "./workshopApprovalPanel.vue?vue&type=style&index=0&id=104e7a00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104e7a00"]])

export default __exports__